var CommonUtils = new function() {
  this.tenderId = null;
  this.tenderState = null;
  this.urls = [];

  this.setUrl = function(name, url) {
    this.urls[name] = url;
  };
  this.getUrl = function(name) {
    return this.urls[name];
  };

  this.bidders = {
    sorted: [],
    restricted: []
  };

  /**
   * From Highcharts library
   * Format a number and return a string based on input settings
   * @param {Number} number The input number to format
   * @param {Number} decimals The amount of decimals
   * @param {String} decPoint The decimal point, defaults to the one given in the lang options
   * @param {String} thousandsSep The thousands separator, defaults to the one given in the lang options
   */
  this.formatNumber = function (number, decimals, decPoint, thousandsSep) {
    var langDefaults = {
      decimalPoint: ".",
      thousandsSep: ","
    };
    var lang = langDefaults.lang,
        n = number, c = isNaN(decimals = Math.abs(decimals)) ? 2 : decimals,
        d = decPoint === undefined ? langDefaults.decimalPoint : decPoint,
        t = thousandsSep === undefined ? langDefaults.thousandsSep : thousandsSep, s = n < 0 ? "-" : "",
        i = parseInt(n = Math.abs(+n || 0).toFixed(c), 10) + "", j = (j = i.length) > 3 ? j % 3 : 0;

    return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) +
      (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
  };

  // Masking methods
  this.maskElement = function(element) {
    if ($(element).length > 0 && ! $(element).isMasked()) {
      $(element).mask("Loading ...");
    }
  };
  this.unmaskElement = function(element) {
    if ($(element).length > 0 && $(element).isMasked()) {
      $(element).unmask();
    }
  };
  this.maskElementWithTimeout = function(element, timeout) {
    setTimeout(function() {
      if ($(element).length > 0 && ! $(element).isMasked()) {
        $(element).mask("Loading ...");
      }
    }, timeout);
  };
  this.unmaskElementWithTimeout = function(element, timeout) {
    setTimeout(function() {
      if ($(element).length > 0 && $(element).isMasked()) {
        $(element).unmask();
      }
    }, timeout);
  };

  this.pollingIntervalID = null;
  this.pollingCallback = null;

  this.loadData = function() {
    var self = this;
    $.ajax({
      url: this.getUrl("loadData"),
      dataType: "json",
      success: function(json){
        if (json) {
          ChartData = json;
          BiddersUtils.renderBiddersList(false);
          BiddersUtils.renderBiddersList(true);
          BiddersUtils.setupSidebarEvents();
          self.stopPolling();
        }
      },
      error: function() {
        self.stopPolling();
      }
    });
  };

  this.stopPolling = function() {
    setTimeout("CommonUtils.pollingCallback()", 100); // Need the biddersList in place first
    clearInterval(this.pollingIntervalID);
    this.pollingIntervalID = null;
    BiddersUtils.unmaskBiddersList();
    ChartUtils.unmaskChart();
  };

  this.pollForData = function(callback) {
    ChartUtils.maskChart();
    BiddersUtils.maskBiddersList();

    this.pollingCallback = callback;
    this.pollingIntervalID = setInterval("CommonUtils.loadData()", 2000);
  };

  this.isDataAvailable = function() {
    return (typeof(ChartData) != 'undefined' && ChartData && typeof(ChartData.totals) != 'undefined' && ChartData.totals.length > 0);
  };

  this._recalculate_average = function(data_array){
    data_array = $(data_array).not([0]).get();
    if(data_array.length == 0){ return 0 }

    var total = data_array.length;
    var average = 0;
    // Calculating average
    $.each(data_array, function(index, serie){
      average += serie;
    });
    return average/total;
  };

  this._recalculate_median = function(data_array){
    data_array = $(data_array).not([0]).get();

    if(data_array.length == 0){ return 0 }

     var total = data_array.length;
     var median = 0;
     var price_array = [];
     //var sorted_array = [];
     // Gathering prices total or individual
     $.each(data_array, function(index, serie){
        price_array.push(serie);

     });
     //Sorting array of prices
     var sorted_array = price_array.sort(function(a,b){return a-b});

     var calculated_total = Math.floor(total/2);

     //Calculating median
     if(total % 2 == 0)
        median += Math.round((sorted_array[calculated_total] + sorted_array[calculated_total-1])) / 2;
     else
        median += Math.round(sorted_array[calculated_total]);

     return median;
  };

};
